import React from "react";
import API from "@/apis";
import { Router, Route, Link, Switch } from "react-router-dom";

import "./index.less";

import { inject, observer } from "mobx-react";
import { SessionStore, RouterStore, LocaleStore } from "@/stores/";
import MineAddress from "./MineAddress";
// import Notice from "./Notice";
import SummaryData from "./SummaryData";
import AccountList from "./AccountList";
import ChartLists from "./ChartLists";
import Compare from "@/components/CompareEarn";
import { Button, Modal } from "antd";

export interface DashboardProps {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "router", "locale")
@observer
class Dashboard extends React.Component<DashboardProps, any> {
  constructor(props) {
    super(props);
  }

  state = {
    summary: {},
  } as any;

  componentDidMount() {
    const { session } = this.props;
    // session.getSubAccountList(); // 获取子账号列表(含主账户)
    session.coinEarn(); //收益预估
    session.getSummary();
    // session.getZeroRate(); // 0费率活动
  }

  render() {
    const { session, locale } = this.props;
    const { subAccountList } = session;
    return (
      <section className="dashboard-container">
        <div className="container">
          {/* 公告列表 */}
          {/* <div className="notice-container">
            <Notice />
          </div> */}
          {/* 预估收益比较 */}
          <div className="compare-container">
            <Compare />
          </div>
          {/* 收益列表 */}
          <div className="summary-container">
            <SummaryData summary={session.summary} isMain={true} />
          </div>
          {/* 子账户列表 */}
          <div className="account-list-container">
            <AccountList />
          </div>
          {/* 统计图表 */}
          <div className="chart-lists-container">
            <ChartLists />
          </div>
          {/* 挖矿地址 */}
          <div className="mine-adress-container">
            <MineAddress />
          </div>
        </div>
      </section>
    );
  }
}

export default Dashboard as React.ComponentClass;
